import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import SelectField from "../fields/SelectField";
import getUserData from "../utils/getUserData";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0px 18px;
	background-color: ${props => (props.theme.colors.lightGrayVitat || "#f2f2f8")};
	border: 1px solid #e9ecef;
	box-shadow: 0px 4px 4px 1px #0000000a;
	border-radius: 8px;
`;

const HeaderWrapper = styled.span`
	padding: 8px 16px;
	font-family: Livvic;
	font-size: 11.5px;
	font-weight: 600;
	line-height: 18px;
	letter-spacing: 0.005em;
	text-align: left;
	color: ${props => (props.theme.colors.blackVitat || "#002b49")};
	border-bottom: 5px solid ${props => (props.theme.colors.brownVitat || "#bfe338")};
	box-sizing: border-box;
`;

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px 13px 22px 13px;
	gap: 8px;
`;

const SelectLabel = styled.label`
	font-family: Livvic;
	font-size: 11.5px;
	font-weight: 400;
	line-height: 18px;
	letter-spacing: 0.005em;
	text-align: left;
`;

interface ProcedureSelectorProps {
	procedures: ProceduresType[] | undefined;
	disabled?: boolean;
}

export type ProceduresType = {
	id: string;
	description: string;
};

const ProcedureSelector = ({ disabled = false, procedures }: ProcedureSelectorProps) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const userData = getUserData();

	const handleProcedureChange = (newValue: ProceduresType) => {
		const selected = newValue;
		navigate(
			{
				pathname: location.pathname,
				search: selected.description.length > 0 ? `?procedure=${selected.id}` : "",
			},
			{
				state: location.state,
				replace: true,
			},
		);
	};

	const getDefaultValue = () => {
		// Caso for enviado o id do procedimento no login, definir ele como valor
		if (!disabled && userData.procedureId) {
			return procedures?.find(option => option.id === userData.procedureId) ?? null;
		}

		const procedure = searchParams.get("procedure");
		if (!procedure || !procedures) return null;
		
		const selected = procedures?.find(option => option.id === procedure) ?? null;

		return selected;
	};

	return (
		<Container style={{
            display:
                getDefaultValue() !== null && (disabled || !!userData.procedureId)
                    ? "none"
                    : undefined,
        }}>
			<HeaderWrapper>Para ver os horários, preencha:</HeaderWrapper>

			<ContentWrapper>
				<SelectLabel htmlFor="select-procedure">Procedimento:</SelectLabel>

				<SelectField
					isDisabled={getDefaultValue() !== null && (disabled || !!userData.procedureId)}
					isSearchable={false}
					placeholder={"Selecione"}
					value={getDefaultValue()}
					onChange={newValue => handleProcedureChange(newValue as ProceduresType)}
					options={procedures}
					getOptionLabel={opt => (opt as ProceduresType).description}
					getOptionValue={opt => (opt as ProceduresType).id}
				/>
			</ContentWrapper>
		</Container>
	);
};
export default ProcedureSelector;
